/**
 * Опрос по кадрам, пока не выполнится условие (например, React Flow измерил ноды).
 * attempt() → true завершает опрос. Первый вызов — через startFrames кадров.
 * После maxAttempts неудач вызывается onExhausted. Возвращает отмену для cleanup эффекта.
 */
export function pollAnimationFrames(
  attempt: () => boolean,
  options: { maxAttempts: number; startFrames?: 1 | 2; onExhausted?: () => void },
): () => void {
  let cancelled = false
  let frame = 0
  let attempts = 0

  const tick = () => {
    if (cancelled || attempt()) return
    attempts += 1
    if (attempts >= options.maxAttempts) {
      options.onExhausted?.()
      return
    }
    frame = requestAnimationFrame(tick)
  }

  if (options.startFrames === 2) {
    frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(tick)
    })
  } else {
    frame = requestAnimationFrame(tick)
  }

  return () => {
    cancelled = true
    cancelAnimationFrame(frame)
  }
}
